/*-----------------------------------------------------------
      START: Above Code moved from 'constants.js' code 
-----------------------------------------------------------*/ 
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
/*-----------------------------------------------------------
      END: Above Code moved from 'constants.js' code 
-----------------------------------------------------------*/ 
/*-----------------------------------------------------------
      START: Above Code moved from 'pubsub.js' code 
-----------------------------------------------------------*/
let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}
/*-----------------------------------------------------------
      END: Above Code moved from 'pubsub.js' code 
-----------------------------------------------------------*/

function getFocusableElements(container) {
  if (!container) return [];

  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

/* Toggle mobile menus */ 
document.querySelectorAll('.menu-drawer__navigation details').forEach((details) => {
    details.addEventListener('toggle', function () {
      if (!this.open) return;

      this.closest('.menu-drawer__navigation')
        .querySelectorAll('details[open]')
        .forEach((other) => {
          if (other !== this) {
            other.removeAttribute('open');
          }
        });
    });
  });



const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      if (details.classList.contains('parent-submenu')) return;
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);


/* class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
}*/


/* START: custom code for autoplay thumbnails video */
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;

    this.deferredElement = null; 

    poster.addEventListener('click', this.loadContent.bind(this));

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadContent();
          } else {
            this.pauseContent();
          }
        });
      },
      { threshold: 0.5 } 
    );

    this.observer.observe(this);
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) this.deferredElement.focus();
      if (this.deferredElement.nodeName == 'VIDEO' && this.deferredElement.getAttribute('autoplay')) {
      
        this.deferredElement.play();
      }
    }
  }

  pauseContent() {
    if (this.deferredElement && this.deferredElement.nodeName == 'VIDEO') {
      this.deferredElement.pause();
    }
  }
}
/* END: custom code for autoplay thumbnails video */


customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  

  // START: Custom dots code 
        this.sliderControlWrapper = this.querySelector('.slider-buttons');
        if (!this.sliderControlWrapper) return;
        this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
        
        this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
        this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    
    // END: Custom dots code 
    
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
      this.prevButton.classList.add('disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
      this.prevButton.classList.remove('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
      this.nextButton.classList.add('disabled');     
    } else {
      this.nextButton.removeAttribute('disabled');
      this.nextButton.classList.remove('disabled');    
    }
  

// START: CUSTOM DOTS NAVIGATIONS
            this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
          this.prevButton.removeAttribute('disabled');
          if (!this.sliderControlButtons.length) return;
          this.sliderControlButtons.forEach(link => {
            link.classList.remove('slider-counter__link--active');
            link.removeAttribute('aria-current');
          });
          this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
          this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
      
      // END : CUSTOM DOTS NAVIGATIONS
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    
        // this.setSlidePosition(this.slideScrollPosition);

     this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

 // START: CUSTOM DOTS NAVIGATION
  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.slider.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
  // END: CUSTOM DOTS NAVIGATION
}
  
customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout (() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this._isUpdating = false;
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateSingleVariantStatus();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      //this.handleBoxspringClass();
      this.handleBoxspringClassv2();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);

      const ar_image_qr_blocks_btns = document.querySelectorAll(`.ar_image_file_btn`);    
       ar_image_qr_blocks_btns.forEach((ar_image_qr_blocks_btn) => {
         ar_image_qr_blocks_btn.removeAttribute("style");       
      });
          
      var get_ar_img_btn = `#ar_image_file_btn_${this.currentVariant.id}`;
      var check_ar_img_btn_element =  document.querySelectorAll(get_ar_img_btn);  
      if (typeof(check_ar_img_btn_element[0]) != 'undefined' && check_ar_img_btn_element[0] != null){   
          check_ar_img_btn_element[0].style.display = 'block';  
      }
    
      var check_element =  document.querySelectorAll('.product_image_div_3d_object');
      if (typeof(check_element[0]) != 'undefined' && check_element[0] != null){   
        
            const media3d_main_section = document.querySelectorAll(`.product_image_div`);
            media3d_main_section[0].setAttribute('data-image-selected-option',this.currentVariant.option1);      
            
            const media3d_blocks_btns = document.querySelectorAll(`.deferred-3d_obj_btn`);    
            media3d_blocks_btns.forEach((media3d_btn) => {
             media3d_btn.removeAttribute("style");
             media3d_btn.setAttribute('data-block-3d-active',"false");       
            });
            
            const media3d_blocks_btn = document.querySelectorAll(`[data-option-type^="${this.currentVariant.option1}"]`);
            if(media3d_blocks_btn[0]){
              media3d_blocks_btn[0].style.display = 'block';
            }
        
            const media3d_blocks = document.querySelectorAll(`.desktop-slider__slide_3d_block`);    
            media3d_blocks.forEach((media3d_block) => {
             media3d_block.removeAttribute("style");
            });
        
            if (window.matchMedia("(max-width: 749px)").matches) {
                const media3d_block_Active = document.querySelectorAll(`[data-option-type-block^="${this.currentVariant.option1}"]`);
                if (media3d_block_Active[0] ) {
                    media3d_block_Active[0].style.display = 'block';      
                }
            }
            
            const pro_media_main_block = document.querySelectorAll(`.product__media-list`);
            if (pro_media_main_block[0]) {
                pro_media_main_block[0].style.display = 'flex';  
            }
        
            const pro_media_main_navigation_one = document.querySelectorAll(`.navigation-one`);
            if (pro_media_main_navigation_one[0] ) {
                pro_media_main_navigation_one[0].style.display = 'block';      
            }
        
      }
    
  }

  updateShareUrl() {

    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

handleBoxspringClassv2() {

  const boxspringAddon =
    document.querySelector('#boxspring-addon');

  if (!boxspringAddon || !this.currentVariant) {
    return;
  }

  const variantTitle =
    String(this.currentVariant.title || '');

  //console.log('CURRENT VARIANT:', variantTitle);


  /*
   * Normalize the variant title.
   *
   * Examples:
   *
   * Queen / 8" - 9"
   * Queen / 6.5" - 7.5"
   * Queen / 5" - 6"
   */
  const normalizedTitle = variantTitle
    .replace(/[″“”]/g, '"')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();


  //console.log('NORMALIZED VARIANT:',normalizedTitle);


/*
 * Check if the selected variant is California King.
 *
 * Matches:
 * California King
 * Cal King
 * Cal-King
 * Cal King / 8" - 9"
 */
const isCalKing =
  /\b(california\s*king|cal[\s-]*king)\b/.test(
    normalizedTitle
  );


//console.log('IS CAL KING:',isCalKing);


/*
 * Check specifically for the 8" - 9" variant.
 *
 * Matches:
 * 8" - 9"
 * 8"-9"
 * 8" – 9"
 * 8"–9"
 */
const isBoxspringHeightCompatible =
  /8"\s*[-–—]\s*9"/.test(
    normalizedTitle
  );


//console.log('HAS 8-9 HEIGHT:',isBoxspringHeightCompatible);


const isBoxspringCompatible =
  !isCalKing &&
  isBoxspringHeightCompatible;



  //console.log('BOX SPRING SHOULD SHOW:',isBoxspringCompatible);


  /*
   * Show / hide box spring.
   */
  if (!isBoxspringCompatible) {

    //boxspringAddon.hidden = true;
//alert(isBoxspringCompatible);
    boxspringAddon.classList.remove('is-visible'); // Add hidden only after the animation finishes 

      document.querySelector('.product-variant-boxspring-id').setAttribute('disabled', 'disabled');
      document.querySelector('.product-variant-boxspring-quantity').setAttribute('disabled', 'disabled');
      document.querySelector('.product-variant-linked-boxspring').setAttribute('disabled', 'disabled');      
      document.querySelector('.product-variant-boxspring-linked-product').setAttribute('disabled', 'disabled');            
      document.querySelector('#customer-adding-boxspring').setAttribute('disabled', 'disabled');   

    setTimeout(() => { 
      if (!boxspringAddon.classList.contains('is-visible')) { 
       // boxspringAddon.setAttribute('hidden', ''); 
      } 
    }, 450);    

    /*
     * Uncheck if customer changes away from
     * the compatible variant.
     */
    const checkbox =
      document.querySelector(
        '#customer-adding-boxspring-panel'
      );

    if (checkbox) {
      checkbox.checked = false;
    }

 //   alert(checkbox); 

    /*
     * Clear selected box spring variant.
     */
    const boxspringInput =
      document.querySelector(
        '#selected-boxspring-variant'
      );

    if (boxspringInput) {
      boxspringInput.value = '';
    }


    //console.log('Box spring hidden');

        document.querySelector('.product-variant-boxspring-id').setAttribute('disabled', 'disabled');
        document.querySelector('.product-variant-boxspring-quantity').setAttribute('disabled', 'disabled');
        document.querySelector('.product-variant-linked-boxspring').setAttribute('disabled', 'disabled');      
        document.querySelector('.product-variant-boxspring-linked-product').setAttribute('disabled', 'disabled');            
        document.querySelector('#customer-adding-boxspring').setAttribute('disabled', 'disabled'); 

    return;
  }


  /*
   * 8" - 9" selected.
   */
 // boxspringAddon.hidden = false;
  boxspringAddon.classList.add('is-visible'); 

  //console.log('Box spring displayed');


  /*
   * Determine frame size from variant title.
   */
  let frameSize = '';


  if (
    /\btwin\b/i.test(variantTitle)
  ) {

    frameSize = 'twin';

  } else if (
    /\bfull\b/i.test(variantTitle)
  ) {

    frameSize = 'full';

  } else if (
    /\bqueen\b/i.test(variantTitle)
  ) {

    frameSize = 'queen';

  } else if (
    /\bking\b/i.test(variantTitle)
  ) {

    frameSize = 'king';

  }


  //console.log('FRAME SIZE:',frameSize);


  /*
   * Find matching box spring variant.
   */
  const boxspringVariants =
    document.querySelectorAll(
      '.boxspring-item'
    );


  let matchingVariant = null;


  boxspringVariants.forEach(
    function(item) {

      const boxspringTitle =
        String(
          item.dataset.boxspringTitle || ''
        ).toLowerCase();


      //console.log('CHECKING BOXSPRING:',boxspringTitle );


      if (
        frameSize &&
        boxspringTitle.includes(frameSize)
      ) {

        matchingVariant = item;

      }

    }
  );


  /*
   * No matching box spring.
   */
  if (!matchingVariant) {

    //console.warn('No matching box spring variant found for:',frameSize);

    return;
  }


  /*
   * Store selected box spring variant ID.
   */
  const boxspringInput =
    document.querySelector(
      '#selected-boxspring-variant'
    );


  if (boxspringInput) {

    boxspringInput.value =
      matchingVariant.dataset.boxspringId;

  }


  /*
   * Update displayed price.
   */
  const priceElement =
    document.querySelector('#boxspring-addon-price');


  if (priceElement) {
    priceElement.textContent = '+' + matchingVariant.dataset.boxspringPrice;

  }


  //console.log('SELECTED BOXSPRING VARIANT:',matchingVariant.dataset.boxspringId);

  //console.log('SELECTED BOXSPRING PRICE:',matchingVariant.dataset.boxspringPrice);

//alert('CURRENT VARIANT'+this.currentVariant.title);
    const targetElement = document.querySelector('.product-boxspring-line-item-container'); 
    const LineItemInputElem = document.querySelector('.boxspring-product-height-line-item');
    const productVariantBoxspringLinkedProduct = document.querySelector('.product-variant-boxspring-linked-product');
    const productVariantLinkedBoxspringID = document.querySelector('.product-variant-linked-boxspring');
    const productVariantBoxspringID = document.querySelector('.product-variant-boxspring-id');  

    productVariantBoxspringLinkedProduct.value = this.currentVariant.id;
    productVariantLinkedBoxspringID.value = matchingVariant.dataset.boxspringId;
}

    handleBoxspringClass() {

//alert("fj");

    const targetElement = document.querySelector('.product-boxspring-line-item-container'); 
    const LineItemInputElem = document.querySelector('.boxspring-product-height-line-item');
    const productVariantBoxspringLinkedProduct = document.querySelector('.product-variant-boxspring-linked-product');
    const productVariantLinkedBoxspringID = document.querySelector('.product-variant-linked-boxspring');
    const productVariantBoxspringID = document.querySelector('.product-variant-boxspring-id');

    if (!targetElement) return;

    const variantTitle = this.currentVariant.title;
    //console.log('CURRENT VARIANT'+variantTitle);

    if(this.currentVariant){
      //console.log(this.currentVariant.available);
      if(this.currentVariant.available == false){
          document.querySelectorAll(`.additional-product-form__boxspring label[data-option-value="add-boxspring-250"]`)[0].classList.add("hide_option_value");
      }else{
          document.querySelectorAll(`.additional-product-form__boxspring label[data-option-value="add-boxspring-250"]`)[0].classList.remove("hide_option_value");
      }
      //additional-product-form__boxspring
    }

    if(productVariantBoxspringLinkedProduct){
        productVariantBoxspringLinkedProduct.value = this.currentVariant.id;
    }    

    if(productVariantLinkedBoxspringID){
        const selectedSizeElement = this.currentVariant.option1;
        const selectedSizeElementBoxS_id = document.querySelectorAll(`.boxspring_product_variant_block [data-boxspring-title="${selectedSizeElement}"]`)[0].getAttribute("data-boxspring-id");
        const selectedSizeElementBoxS_price = document.querySelectorAll(`.boxspring_product_variant_block [data-boxspring-title="${selectedSizeElement}"]`)[0].getAttribute("data-boxspring-price");
        productVariantLinkedBoxspringID.value = selectedSizeElementBoxS_id;
        productVariantBoxspringID.value = selectedSizeElementBoxS_id;
        document.querySelectorAll(`.additional-product-form__boxspring label[data-option-value="add-boxspring-250"]`)[0].innerHTML = `Add a 9" box spring (+${selectedSizeElementBoxS_price})<span class="visually-hidden">Variant sold out or unavailable</span>`;
    }    

    const targetElementFormBoxspring = this.querySelector('.product-form__boxspring'); 
    const formBoxspringVariantTitleOption = targetElementFormBoxspring.querySelector(':checked').value



    const formBoxspringOptionSelected = document.querySelectorAll('[name="Adding a boxspring?"]:checked')[0].value
    //alert(formBoxspringOptionSelected);
    if(formBoxspringOptionSelected){

      const getProInfoFormEl = document.querySelectorAll('product-info product-form')[0];
      if (getProInfoFormEl.classList.contains('onLoad_box_spring_unselected')) {
        //console.log('Element has active class');
          getProInfoFormEl.classList.remove('onLoad_box_spring_unselected');
      } else {
        //console.log('Class not found');
      }

        if(formBoxspringOptionSelected == "No I have my own boxspring"){
            const formVariantBoxspringHeightSelected = document.querySelectorAll('[name="Your Box Spring Height"]:checked')[0].value
            //alert(formVariantBoxspringHeightSelected);    
            const formBoxspringHeightSelected = document.querySelectorAll('[name="line-item-height"]:checked')[0].value

            document.querySelectorAll('input[name="Your Box Spring Height"]').forEach(input => {
              if (formBoxspringHeightSelected.includes(input.value)) {
                input.checked = true;
                input.dispatchEvent(new Event("change", { bubbles: true }));
                //alert("found : "+input.value);
                return false;
              }
            });      
            
        }else{
            const formBoxspringHeightSelected_in = '8" - 9"';
            document.querySelectorAll('input[name="Your Box Spring Height"]').forEach(input => {
              if (formBoxspringHeightSelected_in.includes(input.value)) {
                input.checked = true;
                input.dispatchEvent(new Event("change", { bubbles: true }));
                //alert("found : "+input.value);
                return false;
              }
            });  
        }
    }



    const specificTitle = 'No I have my own boxspring'; // The exact variant title

    //const hasNoBoxspring = this.currentVariant.options.includes(specificTitle);
    const hasNoBoxspring = formBoxspringVariantTitleOption.includes(specificTitle);

    if (hasNoBoxspring) {
      targetElement.classList.add('has-no-boxspring'); // The class to add
      if (!LineItemInputElem) return;
      LineItemInputElem.querySelector('#customer-boxspring-height').removeAttribute('disabled');

      const heightRadios = targetElement.querySelectorAll('.height-line-item-input');
      const heightInput = document.getElementById('customer-boxspring-height');


      // Loop through each radio input
      function updateHeightInput() {
        const checkedRadio = targetElement.querySelector('.height-line-item-input:checked');
        if (checkedRadio) {
          heightInput.value = checkedRadio.value;
        }
      }

      // Run on page load to set default value
      updateHeightInput();

      // Add change listeners to update on user interaction
      heightRadios.forEach(radio => {
        radio.addEventListener('change', function() {
          updateHeightInput();
        });
      });

      document.querySelector('.product-variant-boxspring-id').setAttribute('disabled', 'disabled');
      document.querySelector('.product-variant-boxspring-quantity').setAttribute('disabled', 'disabled');
      document.querySelector('.product-variant-linked-boxspring').setAttribute('disabled', 'disabled');      
      document.querySelector('.product-variant-boxspring-linked-product').setAttribute('disabled', 'disabled');            
      document.querySelector('#customer-adding-boxspring').setAttribute('disabled', 'disabled');    

    } else {
      targetElement.classList.remove('has-no-boxspring');
       if (!LineItemInputElem) return;
      LineItemInputElem.querySelector('#customer-boxspring-height').setAttribute('disabled', 'disabled');

      document.querySelector('.product-variant-boxspring-id').removeAttribute('disabled');
      document.querySelector('.product-variant-boxspring-quantity').removeAttribute('disabled');
      document.querySelector('.product-variant-linked-boxspring').removeAttribute('disabled');
      document.querySelector('.product-variant-boxspring-linked-product').removeAttribute('disabled');          
      document.querySelector('#customer-adding-boxspring').removeAttribute('disabled');        
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
        if (pickUpAvailability && typeof pickUpAvailability.fetchAvailability === 'function') {
          pickUpAvailability.fetchAvailability(this.currentVariant.id);
        }            
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  /*
  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }
    */


  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');

    if (
      productForm &&
      typeof productForm.handleErrorMessage === 'function'
    ) {
      productForm.handleErrorMessage();
    } else {
      // Fallback: clear the existing product form error
      const errorWrapper = section.querySelector('.product-form__error-message-wrapper');
      const errorMessage = section.querySelector('.product-form__error-message');

      if (errorWrapper) {
        errorWrapper.hidden = true;
      }

      if (errorMessage) {
        errorMessage.textContent = '';
      }
    }
  }


  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);      

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        
        /* start-> AL : save ammount price update */  
            
        const variant_data_element = document.querySelector('.section-main-product .product_all_variant_data');
        //console.log(requestedVariantId);
        if(variant_data_element){
          const get_selected_var_save_price_element = variant_data_element.querySelector(`[data-id^="${requestedVariantId}"]`);
            if(get_selected_var_save_price_element){
            const get_selected_var_save_price =   get_selected_var_save_price_element.innerText;          
            
            const SavePriceElement = document.querySelector('.price_save_ammount .save_price__var');
            if(get_selected_var_save_price.length === 0){             
              const save_price_element = document.querySelector('.price_save_ammount');
              if(save_price_element){
                  save_price_element.classList.add('hidden');
              }            
            }else{
              //SavePriceElement.innerText = `${get_selected_var_save_price}`;
              SavePriceElement.innerHTML = `You’re saving <span class="save_price">${get_selected_var_save_price}</span> with this set`;
              const save_price_element = document.querySelector('.price_save_ammount');
              if(save_price_element){
                  save_price_element.classList.remove('hidden');
              }          
            }
          }
        }
        
        /* end-> AL : save ammount price update */ 
    
        /* start-> AL : save ammount price for sets update */ 
        if(variant_data_element){
              const get_selected_var_save_price_element1 = variant_data_element.querySelector(`[data-id^="${requestedVariantId}"]`);
              if(get_selected_var_save_price_element1){
                const get_selected_var_save_set_price =  get_selected_var_save_price_element1.getAttribute('data-saving-onset');
                const get_selected_var_save_price_sale =   get_selected_var_save_price_element1.innerText; 
                const save_pp_element = document.querySelector('.price_save_ammount');
                const SavePPElement = document.querySelector('.price_save_ammount .save_price__var');

                if(get_selected_var_save_set_price && get_selected_var_save_price_sale.length === 0 ){
                  SavePPElement.innerHTML = `You’re saving <span class="save_price">${get_selected_var_save_set_price}</span> with this set`;
                  const save_pp_element = document.querySelector('.price_save_ammount');
                  if(save_pp_element){
                    save_pp_element.classList.remove('hidden');
                  }
                }else if(get_selected_var_save_price_sale.length === 0){                  
                  if(save_pp_element){
                    save_pp_element.classList.add('hidden');
                  } 
                }
              }
            }
        /* end-> AL : save ammount price for sets update */ 

        
        /* start-> AL : Update variant titles */    
            //const FormParent = document.querySelector('product-form[data-section-id="'+sectionId+'"]').classList.add('CCCCCCC');
            const variant_element = document.querySelector('.section-main-product variant-radios');
            if(variant_element){ 
              const current_option_val_1 = variant_element.querySelector('.selected_option_val.selected_option_val_1');
              if(current_option_val_1){
                current_option_val_1.innerText = this.currentVariant.option1;
              }
              const current_option_val_2 = variant_element.querySelector('.selected_option_val.selected_option_val_2');
              if(current_option_val_2){
                current_option_val_2.innerText = this.currentVariant.option2;
              }

              const quick_variant_element = document.querySelector('quick-add-modal variant-radios');  
            if(quick_variant_element){
              const qb_current_option_val_1 = quick_variant_element.querySelector('.selected_option_val.selected_option_val_1');
              if(qb_current_option_val_1){
                qb_current_option_val_1.innerText = this.currentVariant.option1;
              }
              const qb_current_option_val_2 = quick_variant_element.querySelector('.selected_option_val.selected_option_val_2');
              if(qb_current_option_val_2){
                qb_current_option_val_2.innerText = this.currentVariant.option2;
              }
            }
          }

        //console.log(`#variant-radios-${sectionId}` +'SHOWWWWWW');
        /* end-> AL : Update variant titles */  

         /* start-> AL : update sticky price */      
          const sticky_cta_element = document.querySelector('.template-product .sticky-cart-btn__container');
          if(sticky_cta_element){
              const get_selected_var_price = variant_data_element.querySelector(`[data-id^="${requestedVariantId}"]`);
            if(get_selected_var_price){
              const variant_current_price = get_selected_var_price.getAttribute('data-variant-price');
              const SavePriceElement = sticky_cta_element.querySelector('.price-item').innerText = variant_current_price;
            }
          }         
         /* end-> AL : update sticky price */

        /* start-> AL : size accordion content */ 
          const size_accordion_element = document.querySelector('.product_sizes__accordion');
          if(size_accordion_element){
            var selected_size = this.currentVariant.option1;  
             selected_size = selected_size.replace(/\s+/g, '-').toLowerCase();
            selected_size = selected_size.replace('/', '-').toLowerCase();
             // console.log(selected_size); 
              const size_accordion_inner = size_accordion_element.querySelector('.accordion-body');
              const size_accordion_active_tab = size_accordion_inner.querySelector('.accordion-tab___'+selected_size);
              
              const size_accordion_tabs = size_accordion_inner.querySelectorAll('.accordion-tabs');
              size_accordion_tabs.forEach(function(size_accordion_tab) {
                    if(size_accordion_tab){
                        size_accordion_tab.classList.remove('accordion-tab-active');
                    }                                                      
                });
             if(size_accordion_active_tab){
                size_accordion_active_tab.classList.add('accordion-tab-active');
               }
         
            
          }
        /* end-> AL : size accordion content */ 

        /* start -> AL : Limited Edition Fabric Script */ 
        if(variant_data_element){ 
          const product_media_container = document.querySelector('.section-main-product .product__media-list');
          const get_selected_var_ID = variant_data_element.querySelector(`[data-id^="${requestedVariantId}"]`);
            if(get_selected_var_ID){             
              const variant_limited_fabric_tag = get_selected_var_ID.getAttribute('data-limited-fabric');              
              if(variant_limited_fabric_tag == 'true'){                
                var media_tag_container = product_media_container.querySelector('.product-variant-media-tag');
                if(media_tag_container){
                   media_tag_container.classList.remove('hidden-variant-badge');
                }
              }else{
                var media_tag_container = product_media_container.querySelector('.product-variant-media-tag');
                if(media_tag_container){
                  media_tag_container.classList.add('hidden-variant-badge');
                }
              }
            }
        }
        /* end -> AL : Limited Edition Fabric Script */ 

        // handleBoxspringClass();

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateSingleVariantStatus(){
    const SelectedVariant = this.currentVariant.title;    
    function updateVariantLinks(containerSelector) {
          //const is_single_product_variant = document.querySelector('.product-fabric-swatches__container .product-list-swatch__listing');
          const container = document.querySelector(containerSelector);
          if(container){
            var single_product_variant_items = container.querySelectorAll(".product-list-swatch__item");
            if(single_product_variant_items){
                single_product_variant_items.forEach(function(single_pro_variant_item){
                  const single_pro_var_selector_ele = single_pro_variant_item.querySelector('.single-variant-picker__selector');
                  const single_pro_var_selector = single_pro_var_selector_ele.querySelector('select');
                  //const get_single_pro_variant_id = single_pro_var_selector.querySelector(`option[data-var-title='${SelectedVariant}']`).value;
                   //const get_single_pro_variant_id = single_pro_var_selector.querySelector(`option[data-var-title='${SelectedVariant}']`).value;   
                  
                  // if(get_single_pro_variant_id){
                  //   const current_href = single_pro_variant_item.querySelector('.product-list-swatch__link').getAttribute('href');                  
                  //   const href_with_var_id = current_href.split("?")[0]+'?variant='+ get_single_pro_variant_id;
                  //   single_pro_variant_item.querySelector('.product-list-swatch__link').setAttribute('href', href_with_var_id);                  
                  //}
                  const matchingOption = single_pro_var_selector.querySelector(`option[data-var-title='${SelectedVariant}']`);
                    if (matchingOption) {
                        const get_single_pro_variant_id = matchingOption.value;
                        const current_href = single_pro_variant_item.querySelector('.product-list-swatch__link').getAttribute('href');                  
                        const href_with_var_id = current_href.split("?")[0]+'?variant='+ get_single_pro_variant_id;
                        single_pro_variant_item.querySelector('.product-list-swatch__link').setAttribute('href', href_with_var_id); 
      
                      /* start: Hide soldout swatch fabrics  */ 
                      if (single_pro_variant_item.classList.contains('product-list-swatch__current-item')) {
                          return; // Skip this iteration
                        }
                        const get_single_pro_variant_availability = matchingOption.getAttribute('data-variant-status');
                        const check_single_pro_variant_production_sku = matchingOption.getAttribute('data-production-variant');
                        console.log('show status'+ get_single_pro_variant_availability);
                        if(get_single_pro_variant_availability === 'false' && check_single_pro_variant_production_sku === 'true' ){
                           single_pro_variant_item.classList.add('soldout-swatch__item');
                        }else{
                          single_pro_variant_item.classList.remove('soldout-swatch__item');
                        }
                      /* end: Hide soldout swatch fabrics  */ 
                      
                    } else {
                        // Handle the case where the variant option is not found
                        //console.log("Variant option with title", SelectedVariant, "not found");
                    }
                  
                });
            }
          }
        }
      // Apply to Fabric Product Listings
      updateVariantLinks('.product-fabric-swatches__container .product-list-swatch__listing');
      
      // Apply to New Fabric Listings
      updateVariantLinks('.product-list-swatch__container .product-list-swatch__listing');

    /*--------------------------------------------------------------------------
                start: auto update bundle product size 
    ---------------------------------------------------------------------------*/   
    if (this._isUpdating) return;
    // Set the flag to indicate an update is in progress
    this._isUpdating = true;
     try {
        const is_bundle_product = document.querySelector('.product-info__bundle');
         if (is_bundle_product) {
              const selected_var_option = this.currentVariant.option1; 
              const bundle_variant_picker = is_bundle_product.querySelector('.bundle-product-variant__picker');
              if (bundle_variant_picker) {
                  const bundle_size_picker = bundle_variant_picker.querySelectorAll('.product-form__bundle-size-input');                  
                  
                  bundle_size_picker.forEach(function(bundle_size_picker_item) {
                      // Get all radio input elements within this bundle_size_picker_item
                      const get_all_size_inputs = bundle_size_picker_item.querySelectorAll('input[type="radio"]');
                      
                      // Uncheck all radio inputs
                      get_all_size_inputs.forEach(function(get_all_size_input) {
                          get_all_size_input.checked = false; // Uncheck each radio button                                  
                      });
                      
                      // Find and check the radio button with the selected variant option
                      const get_selected_size = bundle_size_picker_item.querySelector(`[data-bundle-input="${selected_var_option}"]`);
                      if (get_selected_size) {
                          get_selected_size.checked = true;                                                
                          get_selected_size.dispatchEvent(new Event('change', { bubbles: true }));                              
                        
                      }
                  });
              } 
          }
       } finally {
          // Reset the flag after the update is done
          this._isUpdating = false;
        }


     /*--------------------------------------------------------------------------
                end: auto update bundle product size 
    ---------------------------------------------------------------------------*/   
    
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/*-----------------------------------------------------------
      START: Header Mega Menu on Hover 
-----------------------------------------------------------*/ 
 let Nav_items = document.querySelector(".header__inline-menu").querySelectorAll("details");    
 Nav_items.forEach(item => { 
   item.addEventListener("mouseover", () => { 
        item.setAttribute("open", true); 
          item.querySelector(".mega-menu-main__container").addEventListener("mouseleave", () => {            
                item.removeAttribute("open");              
          }); 
          item.addEventListener("mouseleave", () => { 
               item.removeAttribute("open");            
          });
   });
 });
/*-----------------------------------------------------------
END: Header Mega Menu on Hover 
-----------------------------------------------------------*/ 


/*-----------------------------------------------------------
      START: 3D Model View
-----------------------------------------------------------*/ 
var check_element =  document.querySelectorAll('.product_image_div_3d_object');
if (typeof(check_element[0]) != 'undefined' && check_element[0] != null){    
  
     let model_3_item_btn = document.querySelectorAll(".deferred-3d_obj_btn");    
     model_3_item_btn.forEach(item => { 
       item.addEventListener("click", () => { 
        let get_click_3d_opt = item.getAttribute('data-option-type');    
        let get_click_3d_opt_status = item.getAttribute('data-block-3d-active');    
    
        const media3d_blocks = document.querySelectorAll(`.desktop-slider__slide_3d_block`);    
        media3d_blocks.forEach((media3d_block) => {
         media3d_block.removeAttribute("style");
        });
    
         
        if(get_click_3d_opt_status == "false") {
            const media3d_active_block = document.querySelectorAll(`[data-option-type-block^="${get_click_3d_opt}"]`);
            media3d_active_block[0].style.display = 'block';
            item.setAttribute('data-block-3d-active',"true");     
    
            const pro_media_main_block = document.querySelectorAll(`.product__media-list`);
            pro_media_main_block[0].style.display = 'none';    
          
            const pro_media_main_navigation_one = document.querySelectorAll(`.navigation-one`);
            pro_media_main_navigation_one[0].style.display = 'none';            
    
            const pro_media_main_navigation_one_mobile = document.querySelectorAll(`.slider-buttons-mobile`);
            pro_media_main_navigation_one_mobile[0].style.display = 'none';                  
    
        }else{
            const media3d_active_block = document.querySelectorAll(`[data-option-type-block^="${get_click_3d_opt}"]`);
            media3d_active_block[0].removeAttribute("style");
            item.setAttribute('data-block-3d-active',"false");    
          
            const pro_media_main_block = document.querySelectorAll(`.product__media-list`);
            pro_media_main_block[0].style.display = 'flex';     
    
            const pro_media_main_navigation_one = document.querySelectorAll(`.navigation-one`);
            pro_media_main_navigation_one[0].style.display = 'block';        
    
            const pro_media_main_navigation_one_mobile = document.querySelectorAll(`.slider-buttons-mobile`);
            pro_media_main_navigation_one_mobile[0].style.display = 'block';                        
        }
    
       // alert(get_click_3d_opt);
    
         
         
       });
     });
    
    
    
    if (window.matchMedia("(max-width: 749px)").matches) {
      /* the viewport is less than or exactly 500 pixels wide */
    
            // 3D Object Section : On Load : Start
                    const media3d_main_section = document.querySelectorAll(`.product_image_div`);
                    if (media3d_main_section[0]) {
                      let get_click_3d_opt = media3d_main_section[0].getAttribute('data-image-selected-option');
                      //alert(get_click_3d_opt);  
                      const media3d_blocks_btns = document.querySelectorAll(`.deferred-3d_obj_btn`);    
                      media3d_blocks_btns.forEach((media3d_btn) => {
                       media3d_btn.removeAttribute("style");
                       media3d_btn.setAttribute('data-block-3d-active',"false");       
                      });
                  
                      const media3d_blocks_btn = document.querySelectorAll(`[data-option-type^="${get_click_3d_opt}"]`);
                      if (media3d_blocks_btn[0]) {
                        media3d_blocks_btn[0].style.display = 'block';
                      }
              
                      const media3d_blocks = document.querySelectorAll(`.desktop-slider__slide_3d_block`);    
                      media3d_blocks.forEach((media3d_block) => {
                       media3d_block.removeAttribute("style");
                      });
      
                      const media3d_active_block = document.querySelectorAll(`[data-option-type-block^="${get_click_3d_opt}"]`);
                      if (media3d_active_block[0]) {
                        media3d_active_block[0].style.display = 'block';
                      }
      
        
                      const pro_media_main_block = document.querySelectorAll(`.product__media-list`);
                      if (pro_media_main_block[0]) {
                        pro_media_main_block[0].style.display = 'flex';
                      }
                  
                      const pro_media_main_navigation_one = document.querySelectorAll(`.navigation-one`);
                      if (pro_media_main_navigation_one[0]) {
                        pro_media_main_navigation_one[0].style.display = 'block';
                      }
                    }
            // 3D Object Section: End
    
    }
    
    window.addEventListener("resize", myFunctionResize);
    function myFunctionResize() {
        if (window.matchMedia("(max-width: 749px)").matches) {
          /* the viewport is less than or exactly 500 pixels wide */
        
                // 3D Object Section : On Load : Start
                        const media3d_main_section = document.querySelectorAll(`.product_image_div`);
                        let get_click_3d_opt = media3d_main_section[0].getAttribute('data-image-selected-option');
                        //alert(get_click_3d_opt);  
                        const media3d_blocks_btns = document.querySelectorAll(`.deferred-3d_obj_btn`);    
                        media3d_blocks_btns.forEach((media3d_btn) => {
                         media3d_btn.removeAttribute("style");
                         media3d_btn.setAttribute('data-block-3d-active',"false");       
                        });
                    
                        const media3d_blocks_btn = document.querySelectorAll(`[data-option-type^="${get_click_3d_opt}"]`);
                        if (media3d_blocks_btn[0]) {
                            media3d_blocks_btn[0].style.display = 'block';          
                        }
                        
                
                        const media3d_blocks = document.querySelectorAll(`.desktop-slider__slide_3d_block`);    
                        media3d_blocks.forEach((media3d_block) => {
                         media3d_block.removeAttribute("style");
                        });
        
                        const media3d_active_block = document.querySelectorAll(`[data-option-type-block^="${get_click_3d_opt}"]`);
                        if (media3d_active_block[0]) {
                            media3d_active_block[0].style.display = 'block';       
                        }
        
          
                        const pro_media_main_block = document.querySelectorAll(`.product__media-list`);
                        if (pro_media_main_block[0]) {
                            pro_media_main_block[0].style.display = 'flex';  
                        }
                    
                        const pro_media_main_navigation_one = document.querySelectorAll(`.navigation-one`);
                        if (pro_media_main_navigation_one[0] ) {
                            pro_media_main_navigation_one[0].style.display = 'block';      
                        }
                // 3D Object Section: End
        
        }else{
            const media3d_main_section = document.querySelectorAll(`.product_image_div`);
            let get_click_3d_opt = media3d_main_section[0].getAttribute('data-image-selected-option');      
            const media3d_active_block = document.querySelectorAll(`[data-option-type-block^="${get_click_3d_opt}"]`);
           if(media3d_active_block[0]){ media3d_active_block[0].removeAttribute("style"); }
            //item.setAttribute('data-block-3d-active',"false");    
          
            const pro_media_main_block = document.querySelectorAll(`.product__media-list`);
            if (pro_media_main_block[0]) {
                  pro_media_main_block[0].style.display = 'flex';     
            }
    
            const pro_media_main_navigation_one = document.querySelectorAll(`.navigation-one`);
            if (pro_media_main_navigation_one[0]) {
                  pro_media_main_navigation_one[0].style.display = 'block';       
            }
        }
    }

}

/*-----------------------------------------------------------
END: 3D Model View
-----------------------------------------------------------*/ 
  function CheckSearchTerm(event) {    
    if (event.keyCode == 13) {
        var GetTargetSearchTerm = event.target.value;    
      let TargetSearchTerm = GetTargetSearchTerm.trim();
      if(TargetSearchTerm == 'fabric swatches' || TargetSearchTerm =='swatches' || TargetSearchTerm == 'fabric' || TargetSearchTerm == 'fabric swatch' || TargetSearchTerm == 'swatch'){
        window.location.href="/collections/complimentary-fabric";
      }
        
    }
}

/*-----------------------------------------------------------
            START: Terms and Condtion
-----------------------------------------------------------*/ 
const ISCustomCheckoutBtn = document.querySelector('#CartDrawer-Checkout');

if(ISCustomCheckoutBtn){
  function CheckoutCheckbox(event) {
      const termsCheckbox = document.querySelector("#termsbox_id");

      if (termsCheckbox?.checked) {
          return true;
      }

      if (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
      } else {
          const checkoutButton = document.querySelector('#CartDrawer-Checkout');

          if (checkoutButton) {
              checkoutButton.disabled = true;
              checkoutButton.style.pointerEvents = 'none';
              checkoutButton.classList.add('disabled');
          }
      }

      alert('You must agree with the terms and conditions of sales to check out');
      return false;
  }
}

const ISCartCustomCheckoutBtn = document.querySelector('#CartPage-CheckoutDisabled');
if(ISCartCustomCheckoutBtn){
   document.addEventListener('DOMContentLoaded', function() {
     const get_termsCheckbox = document.querySelector("#cart_termsbox_id");
     const get_CheckoutButton = document.querySelector('#checkout');
    const get_CustomCheckoutBtn = document.querySelector('#CartPage-CheckoutDisabled');
    if (get_termsCheckbox.checked) {     
       get_CustomCheckoutBtn.classList.add('hidden');
       get_CheckoutButton.classList.remove('hidden');
    } else {     
       get_CustomCheckoutBtn.classList.remove('hidden');
       get_CheckoutButton.classList.add('hidden');
    }
});
  
   function CartCheckoutCheckbox() {       
      const fn_C_termsCheckbox = document.querySelector("#cart_termsbox_id");   
     const fn_C_CheckoutButton = document.querySelector('#checkout');
     const fn_C_CustomCheckoutBtn = document.querySelector('#CartPage-CheckoutDisabled');
         if (fn_C_termsCheckbox.checked) {
                fn_C_termsCheckbox.setAttribute('checked', 'checked');
               fn_C_CustomCheckoutBtn.classList.add('hidden');
              fn_C_CheckoutButton.classList.remove('hidden');
               return true;
         } else {
            alert('You must agree with the terms and conditions of sales to check out');
            fn_C_termsCheckbox.removeAttribute('checked');
           fn_C_CustomCheckoutBtn.classList.remove('hidden');
           fn_C_CheckoutButton.classList.add('hidden');               
            return false;
         }   
   }
}
/*-----------------------------------------------------------
            END: Terms and Condtion
-----------------------------------------------------------*/


/*-----------------------------------------------------------
            START: Product Review slider 
-----------------------------------------------------------*/
// document.addEventListener("DOMContentLoaded", function() {
// const brandWrapper = document.querySelector(".reviews-card-wrapper__Desktop");
// if(brandWrapper){  
//   const brandCarousel = document.querySelector(".reviews-carousel__init-desk");
//   const cardWidth = brandCarousel.querySelector(".review-card-slide").offsetWidth;
//   const productArrowButtons = document.querySelectorAll(".reviews-card-wrapper__Desktop button");
//   const carouselItems = [...brandCarousel.children];
  
//   let isDragging_aa = false,
//     isAutoPlay_aa = true,
//     startX_aa,
//     startScrollLeft_aa,
//     timeoutId_aa;
  
//   let cardsPerView = Math.round(brandCarousel.offsetWidth / cardWidth);
  
//   carouselItems
//     .slice(-cardsPerView)
//     .reverse()
//     .forEach((item) => {
//       brandCarousel.insertAdjacentHTML("afterbegin", item.outerHTML);
//     });
  
//   carouselItems.slice(0, cardsPerView).forEach((item) => {
//     brandCarousel.insertAdjacentHTML("beforeend", item.outerHTML);
//   });
  
//   brandCarousel.classList.add("no-transition");
//   brandCarousel.scrollLeft = brandCarousel.offsetWidth;
//   brandCarousel.classList.remove("no-transition");
  
//   productArrowButtons.forEach((button) => {
//     button.addEventListener("click", () => {
//       brandCarousel.scrollLeft += button.id == "left" ? -cardWidth : cardWidth;
//     });
//   });
  
//   const dragStart_a = (e) => {
//     isDragging_aa = true;
//     brandCarousel.classList.add("dragging_a");
    
//     startX_aa = e.pageX;
//     startScrollLeft_aa = brandCarousel.scrollLeft;
//   };
  
//   const dragging_a = (e) => {
//     if (!isDragging_aa) return; 
//     brandCarousel.scrollLeft = startScrollLeft_aa - (e.pageX - startX_aa);
//   };
  
//   const dragStop_a = () => {
//     isDragging_aa = false;
//     brandCarousel.classList.remove("dragging_a");
//   };
  
//   const infiniteScroll_a = () => {
//     if (brandCarousel.scrollLeft === 0) {
//       brandCarousel.classList.add("no-transition");
//       brandCarousel.scrollLeft = brandCarousel.scrollWidth - 2 * brandCarousel.offsetWidth;
//       brandCarousel.classList.remove("no-transition");
//     }
//     else if (
//       Math.ceil(brandCarousel.scrollLeft) ===
//       brandCarousel.scrollWidth - brandCarousel.offsetWidth
//     ) {
//       brandCarousel.classList.add("no-transition");
//       brandCarousel.scrollLeft = brandCarousel.offsetWidth;
//       brandCarousel.classList.remove("no-transition");
//     }
  
//     clearTimeout(timeoutId_aa);
    
//   };
  
//   const autoPlay = () => {
//     if (window.innerWidth < 800 || !isAutoPlay_aa) return; // Return if the window is smaller than 800 or isAutoPlay_aa is false    
//     timeoutId_aa = setTimeout(() => (brandCarousel.scrollLeft += cardWidth), 2500);
//   };

  
//   brandCarousel.addEventListener("mousedown", dragStart_a);
//   brandCarousel.addEventListener("mousemove", dragging_a);
//   document.addEventListener("mouseup", dragStop_a);
//   brandCarousel.addEventListener("scroll", infiniteScroll_a);
//   brandWrapper.addEventListener("mouseenter", () => clearTimeout(timeoutId_aa));
//   }
// });

/*-----------------------------------------------------------
            END: Product Review slider 
-----------------------------------------------------------*/

/*-----------------------------------------------------------
            START: Product Review slider Mobile
-----------------------------------------------------------*/
// document.addEventListener("DOMContentLoaded", function() {
// const brandWrapper1 = document.querySelector(".reviews-card-wrapper__Mobile");
// if(brandWrapper1){
// const brandCarousel1 = document.querySelector(".reviews-carousel__init-mob");
// const cardWidth1 = brandCarousel1.querySelector(".review-card-slide").offsetWidth;
// const productArrowButtons1 = document.querySelectorAll(".reviews-card-wrapper__Mobile button");
// const carouselItems1 = [...brandCarousel1.children];

// let isDragging_aa = false,
// 	isAutoPlay_aa = true,
// 	startX_aa,
// 	startScrollLeft_aa,
// 	timeoutId_aa;

// let cardsPerView = Math.round(brandCarousel1.offsetWidth / cardWidth1);

// carouselItems1
// 	.slice(-cardsPerView)
// 	.reverse()
// 	.forEach((item) => {
// 		brandCarousel1.insertAdjacentHTML("afterbegin", item.outerHTML);
// 	});

// carouselItems1.slice(0, cardsPerView).forEach((item) => {
// 	brandCarousel1.insertAdjacentHTML("beforeend", item.outerHTML);
// });

// brandCarousel1.classList.add("no-transition");
// brandCarousel1.scrollLeft = brandCarousel1.offsetWidth;
// brandCarousel1.classList.remove("no-transition");

// productArrowButtons1.forEach((button) => {
// 	button.addEventListener("click", () => {
// 		brandCarousel1.scrollLeft += button.id == "Mobileleft" ? -cardWidth1 : cardWidth1;
// 	});
// });

// const dragStart_a = (e) => {
// 	isDragging_aa = true;
// 	brandCarousel1.classList.add("dragging_a");
// 	startX_aa = e.pageX;
// 	startScrollLeft_aa = brandCarousel1.scrollLeft;
// };

// const dragging_a = (e) => {
// 	if (!isDragging_aa) return; 
// 	brandCarousel1.scrollLeft = startScrollLeft_aa - (e.pageX - startX_aa);
// };

// const dragStop_a = () => {
// 	isDragging_aa = false;
// 	brandCarousel1.classList.remove("dragging_a");
// };

// const infiniteScroll_a = () => {
// 	if (brandCarousel1.scrollLeft === 0) {
// 		brandCarousel1.classList.add("no-transition");
// 		brandCarousel1.scrollLeft = brandCarousel1.scrollWidth - 2 * brandCarousel1.offsetWidth;
// 		brandCarousel1.classList.remove("no-transition");
// 	}
// 	else if (
// 		Math.ceil(brandCarousel1.scrollLeft) ===
// 		brandCarousel1.scrollWidth - brandCarousel1.offsetWidth
// 	) {
// 		brandCarousel1.classList.add("no-transition");
// 		brandCarousel1.scrollLeft = brandCarousel1.offsetWidth;
// 		brandCarousel1.classList.remove("no-transition");
// 	}

// 	clearTimeout(timeoutId_aa);
// };

// const autoPlay = () => {
// 	if (window.innerWidth < 800 || !isAutoPlay_aa) return; 
// 	timeoutId_aa = setTimeout(() => (brandCarousel1.scrollLeft += cardWidth1), 2500);
// };

// brandCarousel1.addEventListener("mousedown", dragStart_a);
// brandCarousel1.addEventListener("mousemove", dragging_a);
// document.addEventListener("mouseup", dragStop_a);
// brandCarousel1.addEventListener("scroll", infiniteScroll_a);
// brandWrapper1.addEventListener("mouseenter", () => clearTimeout(timeoutId_aa));
// }
// });
/*-----------------------------------------------------------
            END: Product Review slider Mobile
-----------------------------------------------------------*/

/*-----------------------------------------------------------
      START: Sticky Product ATC Code 
-----------------------------------------------------------*/
  document.addEventListener('DOMContentLoaded', function() {
    // Select elements
    const CartButtonParent = document.querySelector('.product-form');   
    const addToCartContainer_stick = document.querySelector('.template-product-main-section .product_sticky_holder');
   const addToCartContainer = document.querySelector('.template-product-main-section .sticky-cart-btn__container'); 
  const addToCartContainer_stopper = document.querySelector('.template-product-main-section .product_sticky_stopper'); 

  
    const body = document.body;

    if (addToCartContainer) {
        var elementPosition = addToCartContainer_stopper.getBoundingClientRect().top + window.pageYOffset;
        const get_sticky_scheme = addToCartContainer.getAttribute('data-sticky-class');

        function handleScroll() {
            const scrollTop = window.scrollY;

           const elementHeight = addToCartContainer.getBoundingClientRect().height;
            if (scrollTop > elementPosition) {
                body.classList.add('CartBtn__is-sticky');
                addToCartContainer.classList.add('cart-btn-sticky__onScroll');
                addToCartContainer.classList.add(get_sticky_scheme); 
                addToCartContainer_stick.style.height = elementHeight+'px';
            } else {
                body.classList.remove('CartBtn__is-sticky');
                addToCartContainer.classList.remove('cart-btn-sticky__onScroll');
                addToCartContainer.classList.remove(get_sticky_scheme); 
                addToCartContainer_stick.style.height = 0;
            }
        }

        // Add scroll event listener
        window.addEventListener('scroll', handleScroll);
        
        // Initial check
        handleScroll();

        // Optionally: Update position on window resize
        window.addEventListener('resize', () => {
            elementPosition = addToCartContainer_stopper.getBoundingClientRect().top + window.pageYOffset;
            handleScroll(); // Check the scroll position again
        });
    }
});

/*-----------------------------------------------------------
      END: Sticky Product ATC Code 
-----------------------------------------------------------*/
const boxspringLink = document.querySelector('a[href^="#BoxspringHeight"]');

  if (boxspringLink) {
  document.querySelector('a[href^="#BoxspringHeight"]').addEventListener('click', function(e) {
      e.preventDefault();
      
      const target = document.querySelector('.box-spring-section');
      
      // Scroll to the element smoothly
      const headerHeight = document.querySelector('.section-header') ? document.querySelector('.section-header').offsetHeight : 0;
  
      window.scrollTo({
          top: target.offsetTop - headerHeight,
          behavior: 'smooth'
      });
    
  });
}

/*
  Image comparison slider 
*/ 
customElements.get("image-comparison") ||
    customElements.define(
        "image-comparison",
        class extends HTMLElement {
            constructor() {
                super(),
                    (this.button = this.querySelector("button")),
                    (this.isHorizontal = this.dataset.direction === "horizontal"),
                    (this.startDrag = this.onStartDrag.bind(this)),
                    (this.drag = this.onDrag.bind(this)),
                    (this.stopDrag = this.onStopDrag.bind(this)),
                    this.init();
            }
            init() {
                (this.buttonIcon = this.button.querySelector("span")),
                    (this.offset = this.buttonIcon ? this.buttonIcon.offsetWidth / 2 : 20),
                    this.button.addEventListener("touchstart", this.startDrag),
                    this.button.addEventListener("mousedown", this.startDrag);
            }
            animation() {
                this.setAttribute("is-visible", ""),
                    this.classList.add("is-animating"),
                    setTimeout(() => {
                        this.classList.remove("is-animating");
                    }, 1e3);
            }
            onStartDrag(e) {
                e.preventDefault(),
                    document.body.classList.add("body-no-scrollbar"),
                    this.classList.add("is-dragging"),
                    e.type === "mousedown"
                        ? (document.addEventListener("mousemove", this.drag),
                          document.addEventListener("mouseup", this.stopDrag))
                        : e.type === "touchstart" &&
                          (document.addEventListener("touchmove", this.drag),
                          document.addEventListener("touchend", this.stopDrag));
            }
            onStopDrag() {
                document.body.classList.remove("body-no-scrollbar"),
                    this.classList.remove("is-dragging"),
                    document.removeEventListener("mousemove", this.drag),
                    document.removeEventListener("mouseup", this.stopDrag),
                    document.removeEventListener("touchmove", this.drag),
                    document.removeEventListener("touchend", this.stopDrag);
            }
            onDrag(e) {
                 const event = (e.touches && e.touches[0]) || e;
                  let x, distance;

                  if (this.isHorizontal) {
                    x = event.pageX - this.offsetLeft;
                    distance = this.clientWidth;
                  } else {
                    x = event.pageY - this.offsetTop;
                    distance = this.clientHeight;
                  }


                    const rawPercent = (x * 100) / distance;

                    const percent = Math.max(0.1, Math.min(rawPercent, 99.9));

                    this.style.setProperty("--percent", percent + "%");

            }
        }
    );

/*
  Height variant scroll to
*/ 
 document.addEventListener('DOMContentLoaded', () => {
  const VarHeightScroll_trigger = document.querySelector('#height_scroll_trigger');
  if (!VarHeightScroll_trigger) return;

  VarHeightScroll_trigger.addEventListener("click", function (e) {
    e.preventDefault();

      let targetElement = document.querySelector('[data-height-scroll]');
      if (!targetElement) {
        targetElement = document.querySelector('.product_info_tab_section');
      }
      if (!targetElement) return;     

      var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
      var tabWrapperH = 0;
      var ExtraOffset = 64;

      // Check if we're on a mobile device and get the height of the tab wrapper
     const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerH - tabWrapperH - ExtraOffset;

      // Scroll to the target with a smooth behavior
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

      // Trigger tab activation safely
      if (targetElement.hasAttribute('data-height-scroll') && targetElement.getAttribute('role') === 'tab') {
        setTimeout(() => {
          targetElement.setAttribute('aria-selected', 'true');
          targetElement.click();
        }, 300);
      }

  });

  const VarDimensionScroll_trigger = document.querySelector('#dimensionsTabTrigger');
  if (!VarDimensionScroll_trigger) return;

  VarDimensionScroll_trigger.addEventListener("click", function (e) {
    e.preventDefault();

      let targetElementD = document.querySelector('.product_info_tab_section');     
      if (!targetElementD) return;     

      var headerHD = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
      var tabWrapperHD = 0;
      var ExtraOffsetD = 64;

      // Check if we're on a mobile device and get the height of the tab wrapper
     const targetPositionD = targetElementD.getBoundingClientRect().top + window.pageYOffset - headerHD - tabWrapperHD - ExtraOffsetD;

      // Scroll to the target with a smooth behavior
      window.scrollTo({
        top: targetPositionD,
        behavior: 'smooth'
      });
  });
  
 
}); 

/* START: Variant Hover Popup */ 
document.addEventListener('DOMContentLoaded', () => {
  const productInfo = document.querySelector('product-info');
  if (!productInfo) return;

  const variantElem = productInfo.querySelector('variant-radios');
  if (!variantElem) return;

  const popupContainer = document.querySelector('.variant_hover_popup_container');
  if (!popupContainer) return;

  const mediaQuery = window.matchMedia('(max-width: 749px)');

  function closeAllPopups() {
    popupContainer.querySelectorAll('.variant_popup_show').forEach((el) => el.classList.remove('variant_popup_show'));
  }

  function getPopupFromLabel(label) {
    const optionValue = label.getAttribute('data-option-value');
    if (!optionValue) return null;

    return popupContainer.querySelector(`[id="OptionPopup-${optionValue}"]`);
  }

  // CLICK (Mobile)
  variantElem.addEventListener('click', (e) => {
    if (!mediaQuery.matches) return;

    const label = e.target.closest('label');
    if (!label) return;

    const popup = getPopupFromLabel(label);
    if (!popup) return;

    e.stopPropagation(); // prevent immediate close

    closeAllPopups();
    popup.classList.add('variant_popup_show');
  });



  // HOVER (Desktop)
  variantElem.addEventListener('mouseover', (e) => {
    if (mediaQuery.matches) return; // Only desktop

    const label = e.target.closest('label');
    if (!label) return;

    const popup = getPopupFromLabel(label);
    if (!popup) return;

    // Close others first
    closeAllPopups();

    popup.classList.add('variant_popup_show');
    
  });

  // Close all when leaving entire variant area
  variantElem.addEventListener('mouseout', (e) => {
    if (mediaQuery.matches) return;

    // If mouse leaves the whole container
    if (!variantElem.contains(e.relatedTarget)) {
      closeAllPopups();
    }
  });


  // MOBILE: Close popup on button click
  popupContainer.querySelectorAll('.variant_popup_close_btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      if (!mediaQuery.matches) return; // mobile only

      // Find the popup this button belongs to
      const popup = e.target.closest('.variant_popup_show');
      if (!popup) return;

      popup.classList.remove('variant_popup_show');
    });
  });
  /* Tab Code */ 
  // const Popup_variant_tabs_elem = document.querySelector('.variant_hover_popup_tabs');
  // if (!Popup_variant_tabs_elem) return;
  // const tabLinks = Popup_variant_tabs_elem.querySelectorAll('.var-tab-title');
  // const tabContents = Popup_variant_tabs_elem.querySelectorAll('.variant_tab_content');
  // const tabImgContents = Popup_variant_tabs_elem.querySelectorAll('.variant_popup_image');

  // tabLinks.forEach(link => {
  //   link.addEventListener('click', function (e) {

  //     e.preventDefault(); // stop anchor jump

  //     const targetId = this.getAttribute('href').replace('#', '');

  //     // Remove active from all tabs
  //     tabLinks.forEach(tab => tab.classList.remove('active'));

  //     // Hide all content
  //     tabContents.forEach(content => content.classList.remove('active'));

  //     // Hide all content
  //     tabImgContents.forEach(Imgcontent => Imgcontent.classList.remove('active'));

  //     // Activate clicked tab
  //     this.classList.add('active');

  //     // Show correct content
  //     document.getElementById(targetId).classList.add('active');
  //     Popup_variant_tabs_elem.querySelector(`[data-tab-id="${targetId}"]`).classList.add('active');

  //   });
  // });

});
/* END: Variant Hover Popup */ 

// document.addEventListener('DOMContentLoaded', () => {

//   const labels = document.querySelectorAll('.height-line-item-label');
//   const popups = document.querySelectorAll('.variant_hover_popup');

//   labels.forEach(label => {

//     const popupId = label.dataset.targetPopup;
//     const popup = document.getElementById(popupId);

//     if (!popup) return;

//     label.addEventListener('mouseenter', () => {
//       popups.forEach(p => p.classList.remove('active'));
//       popups.forEach(p => p.classList.remove('variant_popup_show'));
      
//       popup.classList.add('active');
//       popup.classList.add('variant_popup_show');
//     });

//     label.addEventListener('mouseleave', () => {
//       popup.classList.remove('active');
//       popup.classList.remove('variant_popup_show');

//     });

//   });

// });
document.addEventListener('DOMContentLoaded', () => {

  const labels = document.querySelectorAll('.height-line-item-label');
  const popupContainer = document.querySelector('.variant_hover_popup_container');
  const mediaQuery = window.matchMedia('(max-width: 749px)');

  if (!popupContainer) return;

  function closeAllPopups() {
    popupContainer
      .querySelectorAll('.variant_popup_show')
      .forEach(el => el.classList.remove('variant_popup_show'));
  }

  labels.forEach(label => {

    const popupId = label.dataset.targetPopup;
    const popup = document.getElementById(popupId);

    if (!popup) return;

    /* MOBILE CLICK */
    if (mediaQuery.matches) {

      label.addEventListener('click', (e) => {
        e.preventDefault();

        const isOpen = popup.classList.contains('variant_popup_show');

        closeAllPopups();

        if (!isOpen) {
          popup.classList.add('variant_popup_show');
        }
      });

    } 
    
    /* DESKTOP HOVER */
    else {
      if (mediaQuery.matches) return;
      label.addEventListener('mouseenter', () => {
        closeAllPopups();
        popup.classList.add('variant_popup_show');
      });

      label.addEventListener('mouseleave', () => {
        popup.classList.remove('variant_popup_show');
      });

      popup.addEventListener('mouseleave', () => {
        popup.classList.remove('variant_popup_show');
      });

    }

  });

});


  /* END: height line item popup */ 


/* START: Variant collapsible Section */ 

const accordionHeaders = document.querySelectorAll(".filedest_inner_title");
var accordionHeadersIndex = 0;
if(accordionHeaders){
  document.querySelectorAll(".fieldset-accordion-item").forEach(el => {
      accordionHeadersIndex = accordionHeadersIndex + 1;
      var set_index_acc_class = "fieldset-accordion-item-index-"+accordionHeadersIndex;
      el.querySelectorAll(".filedest_inner_title .pro_acc_option_index")[0].innerHTML = accordionHeadersIndex;    
      el.classList.add(set_index_acc_class);
  });
  accordionHeaders.forEach(header => {

    header.addEventListener("click", function(e){

      const fieldset_item = this.parentElement;
      const content = fieldset_item.querySelector(".filedest_inner_panel");

      const get_click_title_class = String(e.target.className);
      const get_click_title = this.querySelector(".cust_product_variant_title").innerText;          
      const stringToCheck = "FABRIC:";
//alert(get_click_title);
      if (get_click_title.includes(stringToCheck) && window.matchMedia("(max-width: 749px)").matches) {
          //console.log(e.target);
          const stringToCheck1 = "learn_more_info_popup_btn";
          const stringToCheck2 = "cust_product_variant_title";
          const stringToCheck3 = "selected_option_val";
          if (get_click_title_class.includes(stringToCheck1) || get_click_title_class.includes(stringToCheck2) || get_click_title_class.includes(stringToCheck3)) {
          // alert(get_click_title);
            content.querySelector(".enable_swatch_info_drawer").classList.add("active_swatch_info");        
          }else{
              // close other accordions
              document.querySelectorAll(".fieldset-accordion-item").forEach(el => {

                if(el !== fieldset_item){
                  el.classList.remove("active");
                  //el.querySelector(".filedest_inner_panel").style.maxHeight = null;
                }
              });

              if(fieldset_item.classList.contains("active")){
                fieldset_item.classList.remove("active");
                content.style.maxHeight = null;
              } else {
                fieldset_item.classList.add("active");                
              // content.style.maxHeight = content.scrollHeight + "px";
              }            
          }    

      }else{

          // close other accordions
          document.querySelectorAll(".fieldset-accordion-item").forEach(el => {

            if(el !== fieldset_item){
              el.classList.remove("active");
              //el.querySelector(".filedest_inner_panel").style.maxHeight = null;
            }
          });

          if(fieldset_item.classList.contains("active")){
            fieldset_item.classList.remove("active");
            content.style.maxHeight = null;
          } else {
            fieldset_item.classList.add("active");                
          // content.style.maxHeight = content.scrollHeight + "px";
          }

          const boxSpringFieldset = document.querySelector(
            'fieldset[data-option-title*="box-spring" i]'
          );

          if (boxSpringFieldset?.classList.contains('active')) {
            document.body.classList.add('box-spring-tab-selected');
            //alert("df");
              setTimeout(function () {

                  const selectedInput = document.querySelector(
                    'variant-radios input[type="radio"]:checked, ' +
                    'variant-selects input[type="radio"]:checked, ' +
                    'variant-selects select'
                  );

                  if (!selectedInput) {
                    //console.log('No selected variant input found');
                    return;
                  }

                  //console.log('Triggering initial variant change:',selectedInput.value);

                  selectedInput.dispatchEvent(
                    new Event('change', {
                      bubbles: true
                    })
                  );

                }, 1000);

          }else{
            document.body.classList.remove('box-spring-tab-selected');
          }  

      }

    });

  });  
}

/* END: Variant collapsible Section */ 



/* Dawn Compatible Money Formatter */


window.formatStoreMoney = function (amountInCents) {

  if (!amountInCents) return '';

  const currency = window.storeCurrency?.currency || 'USD';
  const locale = window.storeCurrency?.locale || 'en-US';

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency
  }).format(amountInCents / 100);
};